import { render, staticRenderFns } from "./RelatorioCargaDescargaList.vue?vue&type=template&id=dcbccc22"
import script from "./RelatorioCargaDescargaList.vue?vue&type=script&lang=js"
export * from "./RelatorioCargaDescargaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports